import { createFileRoute } from '@tanstack/react-router'
import { throwLegacyRedirect } from '../lib/legacy-redirect'

export const Route = createFileRoute('/interior')({
  beforeLoad: ({ location }) => {
    throwLegacyRedirect(location.pathname, location.searchStr)
  },
  component: () => null,
  head: () => ({
    title: 'Tailored Detailing | Autoglow Detailing',
    meta: [{ name: 'robots', content: 'noindex,follow' }],
  }),
})
